/* @flow */
import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { translate } from 'react-i18next';
import moment from 'moment';

import type { TranslatorProps } from 'react-i18next';

import type TypeActionDrawerStore from 'stores/ActionDrawerStore';

import Form from 'forms/_.extend';
import Loading from 'components/Loading/Loading';
import ActionDrawerHeader from 'views/ActionDrawer/components/ActionDrawerHeader/ActionDrawerHeader';

import RequestAssetOwnershipForm from './RequestAssetOwnershipForm/RequestAssetOwnershipForm';
import RequestAssetOwnershipSuccess from './RequestAssetOwnershipSuccess/RequestAssetOwnershipSuccess';
import RequestAssetOwnershipError from './RequestAssetOwnershipError/RequestAssetOwnershipError';

import styles from '../../../ActionDrawer.module.scss';

type TypeProps = {
  t: TranslatorProps,
  actionDrawerStore: TypeActionDrawerStore,
  assetStore: Object,
};

@translate()
@inject('actionDrawerStore', 'assetStore')
@observer
export default class RequestAssetOwnership extends React.Component<*> {
  createForm: Function = () => {
    const { t, actionDrawerStore, assetStore }: TypeProps = this.props;

    const asset: Object = this.props.formData;

    let currentEndDate: Date = new Date();

    if (asset.contract && asset.contract.er_end_date) {
      currentEndDate = moment(asset.contract.er_end_date, 'YYYY-MM-DD').toDate();
    }

    const fields: Array<Object> = [
      {
        name: 'requestReason',
        label: t('general:assets.reasons.why_own'),
        fields: [
          {
            name: 'reason',
            label: t('general:reasons.reason_for_wanting_ownership'),
            rules: 'required|string',
            value: '',
            options: [
              {
                id: '1',
                label: t('general:reasons.options.currently_using_asset'),
              },
              {
                id: '2',
                label: t('general:reasons.options.need_asset_for_test'),
              },
              {
                id: '3',
                label: t('general:reasons.options.asset_owner'),
              },
              {
                id: 'other',
                label: t('general:reasons.options.other'),
              },
            ],
          },
        ],
      },
    ];

    const activeUser: Object = JSON.parse(localStorage.getItem('user'));

    const hooks: Object = {
      onInit(data: Object) {
        if (!(asset && asset.account)) {
          assetStore.clearDetails();
          assetStore.loadAsset(asset.id);
        }
      },
      onSuccess(data: Object) {
        const { reason }: Object = data.values().requestReason;

        actionDrawerStore.requestAssetOwnership(asset.id, {
          reason,
          assignee_id: activeUser.id,
        });
      },
    };

    return new Form(
      { fields },
      {
        hooks,
        name: 'requestAssetOwnership',
      }
    );
  };

  render(): React.Node {
    const { t, actionDrawerStore }: TypeProps = this.props;

    const asset: Object = this.props.formData;

    const title: string = t('general:actions.request_ownership_of_asset');

    if (actionDrawerStore.loading) {
      return <Loading />;
    }

    if (actionDrawerStore.error) {
      return (
        <div className={`${styles['action-drawer-form']} ${styles.error}`}>
          <ActionDrawerHeader title={title} />
          <RequestAssetOwnershipError asset={asset} />
        </div>
      );
    }

    if (actionDrawerStore.success) {
      return (
        <div className={`${styles['action-drawer-form']} ${styles.success}`}>
          <ActionDrawerHeader title={title} />
          <RequestAssetOwnershipSuccess response={actionDrawerStore.response} />
        </div>
      );
    }

    return (
      <div className={styles['action-drawer-form']}>
        <ActionDrawerHeader title={title} />
        <RequestAssetOwnershipForm asset={asset} form={this.createForm()} />
      </div>
    );
  }
}
